// extracted by mini-css-extract-plugin
export default {"expandItemText":"TaEBvyLX3e"};